import React from 'react';
import { ModalForm, AfterSubmitProps, FormFieldsData } from 'framework/form';
import { useDocumentStorageContext } from 'framework/documentStorage';
import ProcessAssetsForm from 'domain/gpo/processAssets/createupdate/ProcessAssetsForm';
import { ProcessAssetsType } from 'domain/gpo/processAssets/types';
import { useShowContext } from 'framework/show';

const EditProcessAssetDocumentAction = ({
  modalOpen,
  closeModal,
  afterSubmit,
}: {
  modalOpen: boolean;
  closeModal: () => void;
  afterSubmit: AfterSubmitProps<(response: FormFieldsData) => void>;
}) => {
  const { data } = useShowContext<ProcessAssetsType>();
  const { editDocument, getValidationSchema } = useDocumentStorageContext();

  const documentData = data.getData();

  return (
    <ModalForm
      getValidationSchemaFunc={getValidationSchema}
      modalOpen={modalOpen}
      closeModal={closeModal}
      handleDirty
      submitFormFunc={editDocument}
      afterSubmit={{
        ...afterSubmit,
      }}
      initialData={{
        ...documentData.metadata,
        paths: [documentData.path],
      }}
      isHideDefaultButtons
    >
      <ProcessAssetsForm isEditForm />
    </ModalForm>
  );
};

export default EditProcessAssetDocumentAction;
